<template>

  <div>


    <article class="article" :style="{'background-color': options.cardBgColor }">
      <header class="header">
        <a :href="'/c/' + category.url" v-for="category in options.post.categories" :key="category.id" :style="{'color': options.colorDetails }" class="category">{{ category.name }}</a>
        <h1 class="clean-text-css" :style="options.titleStyle" >
          {{ options.post.title }}
        </h1>
        <div class="meta" style="margin-bottom: 15px">
          <a :href="'/author/' + options.post.author.slug" :style="{'background-color': options.colorDetails }" class="author"> <span class="author-name"> <i class="fa fa-users"></i> {{ options.post.author.name }}</span></a>
          <span class="pub-date">{{ options.post.date_show }}</span>
        </div>
      </header>

      <div class="content-post"  style="overflow-wrap: break-word;" v-html="options.post.content"></div>

      <ul>
        
      </ul>
      <social-bar-clean 
            :facebook_url="facebookUrl()"
            :twitter_url="twitterUrl()"
            :instagram_url="options.author.instagram_url"
            :linkedin_url="linkedinUrl()"
            ></social-bar-clean>
    </article>


  </div>

</template>

<script>

import SocialBarClean from './Snipets/SocialBarClean.vue';


  export default {
    props: ['options'],
    name: 'ThemeCool',
    components: { SocialBarClean },
    methods: {

      facebookUrl(){
        return 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(window.location.href)
      },

      twitterUrl(){
        return "https://twitter.com/share?url="+ encodeURIComponent(window.location.href)
      },

      linkedinUrl(){
        return "https://www.linkedin.com/sharing/share-offsite/?url"+ encodeURIComponent(window.location.href)
      }

    },
    mounted(){
      $('img').css('max-width', '100%');
    }
  }
</script>

<style scoped>

  /*
   * This is an example built for a Thinkful office hour
   * showcasing the stuff you'd want in a "minimal" / minimalist
   * blog template.
   */

  * {
    box-sizing: border-box;
  }

  .img-responsive {
    max-width: 100% !important;
  }

  .category {
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: #ffaa44;
  }

  .article {
    width: 100%; /* default */
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
    padding: 60px 30px;
  }


  .author {
    display: inline-block;
    background-color: #ffaa44;
    color: white;
    border-radius: 5px;
    padding: 8px 20px;
    margin-right: 15px;
  }

  .pub-date {
    line-height: 1;
    display: inline-block;
    vertical-align: baseline;
  }

  p {
    margin-top: 1em;
    margin-bottom: 1em;

  }

  h1 {
    font-size: 2.232em; /* line-height: 3 * 1.75 em; */
    line-height: 1;
  }

  h2 {
    font-size: 1.826em;
    line-height: 1;
  }

  h3 {
    font-size: 1.494em;
    line-height: 1.2;
  }


  figure {
    padding: 0;
  }

  img {
    display: block;
    margin-left: auto;
    margin-right: auto;
    max-width: 100%;
  }


</style>
